export const INVENTORY_COVERAGE_SHIPPED_WINDOW_DAYS = 7;
export const INVENTORY_COVERAGE_EXCLUDES_TODAY = true;
export const INVENTORY_COVERAGE_CRITICAL_DAYS = 7;
export const INVENTORY_COVERAGE_WARNING_DAYS = 14;

export const INVENTORY_COVERAGE_WINDOW_LABEL = 'last 7 days, excl. today';
export const INVENTORY_COVERAGE_BASIS_TOOLTIP =
  'Based on shipped count in the last 7 days, excluding today.';

export type InventoryCoverageLevel = 'critical' | 'warning' | 'ok';

export const getInventoryCoverageLevel = (
  daysCover: number,
): InventoryCoverageLevel => {
  if (!Number.isFinite(daysCover)) return 'ok';
  if (daysCover <= INVENTORY_COVERAGE_CRITICAL_DAYS) return 'critical';
  if (daysCover <= INVENTORY_COVERAGE_WARNING_DAYS) return 'warning';
  return 'ok';
};
